/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FufiFinancialInfoPremiumFrequency } from './FufiFinancialInfoPremiumFrequency';
import {
    FufiFinancialInfoPremiumFrequencyFromJSON,
    FufiFinancialInfoPremiumFrequencyFromJSONTyped,
    FufiFinancialInfoPremiumFrequencyToJSON,
    FufiFinancialInfoPremiumFrequencyToJSONTyped,
} from './FufiFinancialInfoPremiumFrequency';
import type { FufiFinancialInfoPremiumStatus } from './FufiFinancialInfoPremiumStatus';
import {
    FufiFinancialInfoPremiumStatusFromJSON,
    FufiFinancialInfoPremiumStatusFromJSONTyped,
    FufiFinancialInfoPremiumStatusToJSON,
    FufiFinancialInfoPremiumStatusToJSONTyped,
} from './FufiFinancialInfoPremiumStatus';

/**
 * 
 * @export
 * @interface FufiFinancialInfoPremium
 */
export interface FufiFinancialInfoPremium {
    /**
     * 
     * @type {FufiFinancialInfoPremiumFrequency}
     * @memberof FufiFinancialInfoPremium
     */
    frequency: FufiFinancialInfoPremiumFrequency;
    /**
     * 
     * @type {Date}
     * @memberof FufiFinancialInfoPremium
     */
    periodFrom?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof FufiFinancialInfoPremium
     */
    periodTo?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof FufiFinancialInfoPremium
     */
    value: number;
    /**
     * 
     * @type {Date}
     * @memberof FufiFinancialInfoPremium
     */
    dueDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof FufiFinancialInfoPremium
     */
    paymentDate?: Date | null;
    /**
     * 
     * @type {FufiFinancialInfoPremiumStatus}
     * @memberof FufiFinancialInfoPremium
     */
    paymentStatus: FufiFinancialInfoPremiumStatus;
    /**
     * 
     * @type {number}
     * @memberof FufiFinancialInfoPremium
     */
    balance: number;
}



/**
 * Check if a given object implements the FufiFinancialInfoPremium interface.
 */
export function instanceOfFufiFinancialInfoPremium(value: object): value is FufiFinancialInfoPremium {
    if (!('frequency' in value) || value['frequency'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('dueDate' in value) || value['dueDate'] === undefined) return false;
    if (!('paymentStatus' in value) || value['paymentStatus'] === undefined) return false;
    if (!('balance' in value) || value['balance'] === undefined) return false;
    return true;
}

export function FufiFinancialInfoPremiumFromJSON(json: any): FufiFinancialInfoPremium {
    return FufiFinancialInfoPremiumFromJSONTyped(json, false);
}

export function FufiFinancialInfoPremiumFromJSONTyped(json: any, ignoreDiscriminator: boolean): FufiFinancialInfoPremium {
    if (json == null) {
        return json;
    }
    return {
        
        'frequency': FufiFinancialInfoPremiumFrequencyFromJSON(json['frequency']),
        'periodFrom': json['periodFrom'] == null ? undefined : (new Date(json['periodFrom'])),
        'periodTo': json['periodTo'] == null ? undefined : (new Date(json['periodTo'])),
        'value': json['value'],
        'dueDate': (new Date(json['dueDate'])),
        'paymentDate': json['paymentDate'] == null ? undefined : (new Date(json['paymentDate'])),
        'paymentStatus': FufiFinancialInfoPremiumStatusFromJSON(json['paymentStatus']),
        'balance': json['balance'],
    };
}

export function FufiFinancialInfoPremiumToJSON(json: any): FufiFinancialInfoPremium {
    return FufiFinancialInfoPremiumToJSONTyped(json, false);
}

export function FufiFinancialInfoPremiumToJSONTyped(value?: FufiFinancialInfoPremium | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'frequency': FufiFinancialInfoPremiumFrequencyToJSON(value['frequency']),
        'periodFrom': value['periodFrom'] === null ? null : ((value['periodFrom'] as any)?.toISOString()),
        'periodTo': value['periodTo'] === null ? null : ((value['periodTo'] as any)?.toISOString()),
        'value': value['value'],
        'dueDate': ((value['dueDate']).toISOString()),
        'paymentDate': value['paymentDate'] === null ? null : ((value['paymentDate'] as any)?.toISOString()),
        'paymentStatus': FufiFinancialInfoPremiumStatusToJSON(value['paymentStatus']),
        'balance': value['balance'],
    };
}

